<template>
    <div class="m-portlet  m-portlet--head-sm" v-loading="$parentInfo.dialog_ChooseClass_loading">
        <div class="m-portlet__head m-portlet__head-caption">
            <div style="float:left;">
                <el-row :gutter="24" style="padding-top: 10px;width: 800px">
                    <el-col :span="7">
                        <el-select v-model="$parentInfo.filter.semester_id" placeholder="请选择"
                                   @change="handleShow">
                            <el-option
                                    v-for="item in $parentInfo.semesters"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="8">
                        <small>结束日期：</small>
                        <el-date-picker
                                v-model="$parentInfo.filter.date"
                                type="date"
                                clearable
                                style="width: 150px"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                @change="handleShow()">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="5">
                        <el-select v-model="$parentInfo.filter.grade_id"
                                   @change="changeGrade"
                                   multiple
                                   clearable
                                   placeholder="请选择年级">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <el-switch
                                v-model="$parentInfo.showStudent" @change="showStudentFuc"
                                active-text="显示学生"
                                size="small">
                        </el-switch>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="m-portlet__body ">
            <div style="position: relative;overflow: hidden;">
                <div class="left cart-type" :style="{'height':clientHeight-96-53.2-45.5-100+'px'}" ref="cartScroll">
                    <div class="cart-item" v-for="(item,index) in $parentInfo.studentCarts" :key="index"
                         :style="{'height':$parentInfo.timeTable.V4rectH+'px'}"
                         @click="deleteClassToCart(item[0].cart_id,item[0].id)">{{item[0].name}}
                    </div>
                </div>
                <div class="right">
                    <V4Table v-if="$parentInfo.V4Judge" ref="V4Table"
                             @handleMouseDown="handleMousedown"
                             @cartScroll="cartScroll">
                    </V4Table>
                </div>
            </div>
        </div>
        <el-dialog
                title="创建课程"
                :visible.sync="$parentInfo.dialog_CreateClass_Semester.cartTableDialogVisible"
                width="650px"
                height="700px"
                :before-close="handleClose"
                append-to-body>
            <Dialog_CreateClass_Semester v-if="$parentInfo.dialog_CreateClass_Semester.cartTableDialogVisible"></Dialog_CreateClass_Semester>
        </el-dialog>
    </div>

</template>

<script>
    import index from '../../../../TimeTable/Semester/Index'
    import Dialog_CreateClass_Semester from '../../../../TimeTable/Semester/dialogs/Dialog_CreateClass_Semester'

    export default {
        name: "Dialog_ChooseClass",
        data() {
            return {
                dialogVisible: false,
                subject: '',
                teacher: '',
                semester: '',
                type: 'cart_semesterTable'
            }
        },
        components: {
            'V4Table': index,
            'Dialog_CreateClass_Semester': Dialog_CreateClass_Semester
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            powers() {
                return this.$store.state.config.powers;
            },
            orderStudentCarts: function () {
                return this._.orderBy(this.$parentInfo.studentCarts, 'sortBy', 'asc');
            },
            grades() {
                for (let i in this.$parentInfo.gradesInfo) {
                    if (this.$parentInfo.gradesInfo[i].name === '毕业') {
                        this.$delete(this.$parentInfo.gradesInfo, this.$parentInfo.gradesInfo[i].id);
                    }
                }
                return this.$parentInfo.gradesInfo;
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$wApi.addListen(this.$parentInfo.path, this.handleData);
            this.handleShow();
            this.getAvailableClassrooms();
        },
        mounted() {

        },
        methods: {
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'store_class':
                        this.$parentInfo.dialog_CreateClass_Semester.button_loading = false;
                        this.$nextTick(() => {
                            this.$refs.V4Table.initCanvas();
                        });
                        break;
                    case 'store_class_error':
                        this.$parentInfo.dialog_CreateClass_Semester.button_loading = false;
                        break;
                }
            },
            getAvailableClassrooms(student_num = 10) {
                this.$wApi.send(this.$parentInfo.path, 'get_classrooms', {
                    'template_time_id': this.$parentInfo.cell.template_time_id,
                    'semester_id': this.$parentInfo.filter.semester_id,
                    'student_num': student_num,
                });
            },
            handleShow() {
                this.$parentInfo.dialog_ChooseClass_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'showTable', {
                    'semester_id': this.$parentInfo.filter.semester_id,
                    'end_date':this.$parentInfo.filter.date
                });
                this.$wApi.send(this.$parentInfo.path, 'get_student_carts_to_timeTable', {
                    'semester_id': this.$parentInfo.filter.semester_id,
                    'student_id': this.$parentInfo.student.id,
                });
                this.$parentInfo.cell.selectable = false;
                this.$parentInfo.V4Judge = false;
            },
            changeGrade(){
                for(let subject_id in this.$parentInfo.teachers){
                    for (let key in this.$parentInfo.teachers[subject_id]) {
                        var teacherGrades=this.$parentInfo.teachers[subject_id][key].grades
                        let union = teacherGrades.filter(v => this.$parentInfo.filter.grade_id.includes(v))
                        if(union.length==0 && this.$parentInfo.filter.grade_id.length>0){
                            this.$parentInfo.teachers[subject_id][key].view=false;
                        }else{
                            this.$parentInfo.teachers[subject_id][key].view=true;
                        }
                    }
                }
                var start=0;
                this.$parentInfo.tempLength=0;
                for(let key1 in this.$parentInfo.subjects){

                    let teacherView=0;
                    for (let teacher_id in this.$parentInfo.teachers[key1]) {
                        if(this.$parentInfo.teachers[key1][teacher_id].view){
                            teacherView+=1;
                        }
                    }

                    if(teacherView==0 &&  this.$parentInfo.filter.grade_id.length==0){
                        teacherView=1;
                    }

                    this.$parentInfo.subjects[key1].dataLength=teacherView
                    this.$parentInfo.subjects[key1].rect=[this.$parentInfo.tempLength+start*0.1,0,teacherView,1]
                    this.$parentInfo.tempLength+=teacherView;
                    if(teacherView==0){
                        this.$parentInfo.subjects[key1].view=false;
                    }else{
                        this.$parentInfo.subjects[key1].view=true;
                        start=start+1;
                    }
                }
                setTimeout(()=>{
                    this.$refs.V4Table.initCanvas();
                },100)
            },
            handleMousedown(data) {
                if (data.data.type === "class") {
                    let classx = this.$parentInfo.classes[data.data.teacher_id][data.data.template_time_id][0];
                    this.$wApi.send('/student/' + this.$parentInfo.student.id, 'add_class_to_cart', {
                        'class_id': classx.class_id,
                        'student_id': this.$parentInfo.student.id,
                        'change_studentPeriod_id': this.$store.state.modal.data.studentPeriod_id
                    });
                } else {
                    if (this.powers.includes(49)) {
                        this.$parentInfo.modalData = {
                            subject: this.$parentInfo.subjects[data.data.subject_id],
                            teacher: this.$parentInfo.teachers[data.data.subject_id][data.data.teacher_id],
                            timeData: this._.find(this.$parentInfo.timeData, ['id', data.data.template_time_id]),
                            semester: this.$parentInfo.semesters[this.$parentInfo.filter.semester_id],
                            start_date: this.$parentInfo.start_date,
                        };

                        this.$parentInfo.dialog_CreateClass_Semester.cartTableDialogVisible = true;
                    }
                }

            },
            deleteClassToCart(cart_id, template_time_id) {
                this.$wApi.send('/student/' + this.$parentInfo.student.id, 'delete_cart', {
                    'cart_id': cart_id,
                    'student_id': this.$parentInfo.student.id,
                    'template_time_id': template_time_id
                });
            },
            //老师调换位置
            showStudentFuc() {
                // this.V4Judge = false;
                this.$parentInfo.disableType = !this.$parentInfo.disableType;
                // this.showStudent = !this.showStudent;
                this.$parentInfo.timeTable.V4rectH = (this.$parentInfo.showStudent ? 200 : 50) * window.devicePixelRatio;
                this.$parentInfo.timeTable.V4divi = this.$parentInfo.showStudent ? 8 : 2;
                this.$nextTick(function () {
                    this.$refs.V4Table.initCanvas()
                });
            },
            cartScroll(scrollTop) {
                this.$refs.cartScroll.scrollTop = scrollTop;
            },
            handleClose(done) {
                done();
            }
        }

    }

</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 120px;
    }


    .cart-type {
        position: absolute;
        top: 100px;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .cart-item {
        border: 2px solid #ededed;
        border-bottom: none;
        font-size: 13px;
        line-height: 25px;
        text-align: center;

        &:last-of-type {
            height: 52px;
            border-bottom: 2px solid #ededed;
        }
    }

    .right {
        margin-left: 125px;
    }

    /*.left {*/
    /*    float: left;*/
    /*    width: 800px;*/
    /*    padding-top: 10px;*/
    /*}*/

    /*.right {*/
    /*    margin-left: 810px;*/
    /*    padding-top: 10px;*/
    /*}*/
</style>

